import { useRoutes } from "react-router-dom"
import { AppRoutes } from "./AppRoutes"

export const Routes = () => {
    return useRoutes([
        ...AppRoutes
    ])
}